//angular modules
//DSS Documentation on Angular - http://tiny.sc/cgangular
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

//soco modules
import { SocoAlertModule } from '@soco/alert';
import { SocoCommonModule } from '@soco/common';
import { SocoConfigurationModule } from '@soco/configuration';
import { SocoCoreModule } from '@soco/core';
import { SocoFormsModule } from '@soco/forms';
import { SocoHttpModule } from '@soco/http';
import { SocoModalModule } from '@soco/modal';

//kendo modules
//Kendo Grid Documentation - https://www.telerik.com/kendo-angular-ui/components/grid/
//import { GridModule } from '@progress/kendo-angular-grid';

//modules
import { CoreModule } from '../core/core.module';

//components
//DSS Documentation on Angular Components - http://tiny.sc/cgangularcomponent
import { SampleAddComponent } from './add/sample-add.component';
import { SampleEditComponent } from './edit/sample-edit.component';
import { SampleListComponent } from './list/sample-list.component';

const MODULE_DIRECTIVES = [
    SampleAddComponent,
    SampleEditComponent,
    SampleListComponent
];

@NgModule({
    imports: [
        //angular modules
        BrowserModule,
        FormsModule,
        HttpClientModule,
        ReactiveFormsModule,

        //soco modules
        SocoAlertModule,
        SocoCommonModule,
        SocoConfigurationModule,
        SocoCoreModule,
        SocoFormsModule,
        SocoHttpModule,
        SocoModalModule,

        //kendo modules
        //GridModule,

        //app modules
        CoreModule
    ],
    exports: MODULE_DIRECTIVES,
    declarations: MODULE_DIRECTIVES
})
export class SampleModule { }
